import React from "react";

const VideoDetail = ({ video }) => {
  if (!video) {
    return <div>Loading...</div>;
  }

  const videoId = video.id.videoId;
  const url = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div className="video-detail col-md-8">
      <div className="embed-responsive embed-responsive-16by9">
        <iframe title="Selected Video" className="embed-responsive-item" src={url} />
      </div>
      <div className="details">
        <div id="title">{video.snippet.title}</div>
        <div id="description">{video.snippet.description}</div>
      </div>
    </div>
  );
};

export default VideoDetail;



// WEBPACK FOOTER //
// ./src/components/video_detail.js